<template>
<div id="app">
    <router-view />
    <audio id="myAudio" ref="bgmp3" src="./assets/mp3/bg.mp3" loop></audio>
    <!-- <audio id="myAudio2" ref="bgmp3Two" src="./assets/mp3/game-bg.mp3" loop></audio> -->
    <div v-show="showMusic" :class="music_on?'music_box music_rotate':'music_box'" :style="{backgroundImage: musicImgUrl, backgroundSize:'cover',backgroundRepeat:'no-repeat',backgroundPosition:'center'}" @click="mp3Control"></div>
</div>
</template>

<script>
export default {
    data() {
        return {
            music_on: true,
            musicImgUrl: "url(" + require("./assets/H5img/music_on.png") + ")",
            showMusic: false,

        };
    },
    // 监听,当路由发生变化的时候执行
    watch: {
        $route(to, from) {
            let href = to.path
            console.log(href)
            if (href == '/H5BackLogin' || href == '/H5BackHome' || href == '/H5Checkandreceive' || href == '/H5Listofawards' || href == '/BackLogin' || href == '/BackHome' || href == '/Information' || href == '/WelcomeSitting' || href == '/KeywordsSittings' || href == '/KeywordsEdit' || href == '/keywordsAdd') {
                this.showMusic = false
            } else {
                this.showMusic = true
            }
        }
    },
    methods: {
        mp3Control() {
            if (this.music_on) {
                document.getElementById('myAudio').pause()
                this.music_on = false;
                this.musicImgUrl =
                    "url(" + require("./assets/H5img/music_off.png") + ")";
            } else {
                document.getElementById('myAudio').play()
                this.music_on = true;
                this.musicImgUrl =
                    "url(" + require("./assets/H5img/music_on.png") + ")";
            }
        },

        // 倒计时
        timer(time) {
            var nowtime = new Date();
            var endTime = new Date(time);
            var lefttime = parseInt((endTime.getTime() - nowtime.getTime()) / 1000);
            var d = parseInt(lefttime / (24 * 60 * 60));
            var h = parseInt((lefttime / (60 * 60)) % 24);
            var m = parseInt((lefttime / 60) % 60);
            var s = parseInt(lefttime % 60);
            if (lefttime <= 0) {
                localStorage.setItem('game-over', 1)
            } else {
                localStorage.setItem('game-over', 0)
            }
        },

        //获取微信sdk
        //获取jsconfig
        getJsSDKConfig() {
            this.$axios.post('/weixin/api/getJsSDKConfig', {
                url: window.location.href
            }, {}).then((res) => {
                if (res.data.code === 0) {
                    let JsSDKConfig = res.data.data
                    console.log(JsSDKConfig)
                    let appId1 = JsSDKConfig.appId;
                    let timestamp1 = JsSDKConfig.timestamp;
                    let nonceStr1 = JsSDKConfig.nonceStr;
                    let signature1 = JsSDKConfig.signature;
                    window.wx.config({
                        debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
                        appId: appId1, // 必填，公众号的唯一标识
                        timestamp: timestamp1, // 必填，生成签名的时间戳
                        nonceStr: nonceStr1, // 必填，生成签名的随机串
                        signature: signature1, // 必填，签名，见附录1
                        jsApiList: [
                            "checkJsApi",
                            "onMenuShareTimeline",
                            "onMenuShareAppMessage",
                            "onMenuShareQQ",
                            "onMenuShareQZone",
                            "onMenuShareWeibo",
                            "updateAppMessageShareData",
                            "updateTimelineShareData",
                            "hideMenuItems",
                            "showMenuItems",
                            "hideAllNonBaseMenuItem",
                            "showAllNonBaseMenuItem",
                            "translateVoice",
                            "startRecord",
                            "stopRecord",
                            "onRecordEnd",
                            "playVoice",
                            "pauseVoice",
                            "stopVoice",
                            "uploadVoice",
                            "downloadVoice",
                            "chooseImage",
                            "previewImage",
                            "uploadImage",
                            "downloadImage",
                            "getNetworkType",
                            "openLocation",
                            "getLocation",
                            "hideOptionMenu",
                            "showOptionMenu",
                            "closeWindow",
                            "scanQRCode",
                            "chooseWXPay",
                            "openProductSpecificView",
                            "addCard",
                            "chooseCard",
                            "openCard"
                        ] // 必填，需要使用的JS接口列表，所有JS接口列表见附录2
                    });
                }
            })
        },
        /**
         * 根据参数名 获取 URL 路径中的参数
         * @param {String} name 要读取的参数名称
         */
        getUrlParam(name) {
            var reg = new RegExp('(^|&)' + name + '=([^&]*)(&|$)')
            let url = window.location.href.split('#')[0]
            let search = url.split('?')[1]
            if (search) {
                var r = search.substr(0).match(reg)
                if (r !== null) return unescape(r[2])
                return null
            } else {
                return null
            }
        },
    },
    created() {
        let href = this.$route.path
        console.log(href)
        if (href == '/H5BackLogin' || href == '/H5BackHome' || href == '/H5Checkandreceive' || href == '/H5Listofawards' || href == '/BackLogin' || href == '/BackHome' || href == '/Information' || href == '/WelcomeSitting' || href == '/KeywordsSittings' || href == '/KeywordsEdit' || href == 'keywordsAdd') {
            this.showMusic = false
        } else {
            this.showMusic = true
        }
    },
    mounted() {
        //判断活动是否已结束
        this.timer('2020-06-06 00:00:00')
        this.getJsSDKConfig()
        if (this.music_on) {
            this.musicImgUrl = "url(" + require("./assets/H5img/music_on.png") + ")";
        } else {
            this.musicImgUrl =
                "url(" + require("./assets/H5img/music_off.png") + ")";
        }
        document.addEventListener(
            "WeixinJSBridgeReady",
            function () {
                document.getElementById("myAudio").play();
            },
            false
        );

    },
    beforeDestroy() {
        // localStorage.removeItem('game-over')
        // localStorage.removeItem('gameNum')
    }
};
</script>

<style lang="stylus">
#app font-family Avenir,
Helvetica,
Arial,
sans-serif -webkit-font-smoothing antialiased -moz-osx-font-smoothing grayscale html::-webkit-scrollbar {
    width: 0px;
}

html,
body,
#app,
.layout,
.ivu-row-flex {
    height: 100%;
    -webkit-transform: translate3d(0, 0, 0);
    transform: translate3d(0, 0, 0);
}

.clearfix:before,
.clearfix:after {
    content: '.';
    display: block;
    visibility: hidden;
    height: 0;
    line-height: 0;
    font-size: 0;
}

.clearfix:after {
    clear: both;
}

.clearfix {
    zoom: 1;
}

.clear {
    clear: both;
    height: 0;
    overflow: hidden;
}

.fl {
    float: left;
}

.fr {
    float: right;
}

.masking {
    position: fixed;
    width: 100%;
    height: 100vh;
    top: 0;
    left: 0;
    background: rgba(0, 0, 0, 0.6);
    z-index: 10;
}

.show {
    animation: show 0.3s linear forwards;
}

@keyframes show {
    from {
        opacity: 0;
    }

    to {
        opacity: 1;
    }
}

/* 弹窗 */
.game-modal {
    position: absolute;
    top: 35%;
    left: 50%;
    transform: translateX(-50%);
    text-align: center;
    z-index: 11;
}

.model-top {
    position: absolute;
    top: -2.2rem;
    left: 50%;
    transform: translateX(-50%);
    width: 6.02rem;
    height: 3.38rem;
    background: url('./assets/H5img/model/model-top.png');
    background-size: cover;
    background-position: center;
}

.model-main {
    width: 5.03rem;
    /* height: 4.1rem; */
    padding: 0.9rem 0.65rem;
    background: #f2dbaa;
    border-radius: 0.3rem;
    font-size: 0.3rem;
    color: #31302e;
    line-height: 1.6;
    font-weight: 600;
}

.model-bottom {
    position: absolute;
    left: 50%;
    bottom: -0.6rem;
    transform: translateX(-50%);
    width: 5.31rem;
    height: 1.27rem;
    background: url('./assets/H5img/model/model-cloud.png');
    background-size: cover;
    background-position: center;
}

.modal-close {
    position: absolute;
    top: 0;
    right: 0.1rem;
    width: 0.49rem;
    height: 0.48rem;
    background: url('./assets/H5img/model/close-icon.png');
    background-size: cover;
    background-position: center;
}

/* 音乐 */
.music_box {
    width: 0.73rem;
    height: 0.73rem;
    position: absolute;
    top: 0.8rem;
    right: 0.2rem;
    -webkit-background-size: 100% 100%;
    background-size: 100% 100%;
    background-position: bottom center;
    background-repeat: no-repeat;
    z-index: 9;
    opacity: 1;
}

.music_rotate {
    transform: rotate(0deg);
    -ms-transform: rotate(0deg);
    /* IE 9 */
    -moz-transform: rotate(0deg);
    /* Firefox */
    -webkit-transform: rotate(0deg);
    /* Safari 和 Chrome */
    -o-transform: rotate(0deg);
    animation: musicFlash 3s linear 0s normal infinite forwards;
    -webkit-animation: musicFlash 3s linear 0s normal infinite forwards;
}

@keyframes musicFlash {
    0% {
        transform: rotate(0deg);
    }

    100% {
        transform: rotate(360deg);
    }
}

.gameover-time {
    width 100%;
    font-size 0.24rem;
    color #31302e;
    text-align center;
    margin-top 0.1rem;
}
</style>
